import * as React from 'react';
import VmResourceDistributionGrpah from './VmResourceDistributionGraph';
import styled from '@emotion/styled';
import { DropdownMenu } from '@liveoptics/react-ui';
import {
  HorizontalGaugeBarSeries,
  Series
} from '@liveoptics/react-ui/dist/types/interfaces/Charts';
import ProvisioningContrastGraph from './ProvisioningContrastGraph';
import { ProvisioningContrastPoint } from '../models/views/provisioningContrastGraphViewModel';
import OverProvisioningGraph from './OverProvisioningGraph';
import { OverProvisioningPoint } from '../models/views/overProvisioningGraphViewModel';
import OverProvisioningPerfGraph from './OverProvisioningPerfGraph';

enum GraphType {
  VmResourceDistribution,
  ProvisioningContrast,
  None,
  OverProvisioning,
  OverProvisioningPerfGraph
}

interface State {
  selectedGraph: GraphType;
}

const GraphSummaryWrapper = styled.div`
  padding: 0px 40px 20px 40px;
`;

const DropdownMenuContainer = styled.div`
  padding: 25px 0px 0px 40px;
  position: absolute;
  width: 340px;
`;

const FallbackText = styled.p`
  text-align: center;
  max-width: 100%;
`;

interface Props {
  data: {
    vmResourceDistributionGraphData: HorizontalGaugeBarSeries[];
    provisioningContrastGraphData: ProvisioningContrastPoint[] | undefined;
    overProvisioningGraphData: OverProvisioningPoint[] | undefined;
    overProvisioningPerfGraph: OverProvisioningPoint[] | undefined;
  };
  noData: boolean;
}

function GetGraphTypeFromName(chartName: string): GraphType {
  switch (chartName) {
    case 'Provisioning Contrast':
      return GraphType.ProvisioningContrast;
    case 'Over Provisioning':
      if(window.ShowNewVirtualCharts) {
        return GraphType.OverProvisioningPerfGraph;
      } else {
        return GraphType.OverProvisioning;
      }
    case 'VM Resource Distribution':
    default:
      return GraphType.VmResourceDistribution;
  }
}

class GraphsSummaryBody extends React.Component<Props> {
  state = {
    selectedGraph: GraphType.VmResourceDistribution
  } as State;

  render() {
    return this.props.noData ? (
      <FallbackText>No data to display</FallbackText>
    ) : (
      <div>
        <DropdownMenuContainer>
          <DropdownMenu
            onChange={(ev: { target: { value: string } }) =>
              this.setState({ selectedGraph: GetGraphTypeFromName(ev.target.value) })
            }
          >
            <option value="VM Resource Distribution">VM Resource Distribution</option>
            <option value="Provisioning Contrast">Provisioning Contrast</option>
            <option value="Over Provisioning">Over Provisioning</option>
          </DropdownMenu>
        </DropdownMenuContainer>
        <GraphSummaryWrapper>
          <VmResourceDistributionGrpah
            data={this.props.data.vmResourceDistributionGraphData}
            showGraph={this.state.selectedGraph === GraphType.VmResourceDistribution}
          />
          <ProvisioningContrastGraph
            data={this.props.data.provisioningContrastGraphData}
            showGraph={this.state.selectedGraph === GraphType.ProvisioningContrast}
          />
          <OverProvisioningGraph
            data={this.props.data.overProvisioningGraphData}
            showGraph={this.state.selectedGraph === GraphType.OverProvisioning}
          />
           <OverProvisioningPerfGraph
            data={this.props.data.overProvisioningGraphData}
            showGraph={this.state.selectedGraph === GraphType.OverProvisioningPerfGraph}
          />
        </GraphSummaryWrapper>
      </div>
    );
  }
}
export default GraphsSummaryBody;
